import { ListingModalService, LessonService, ObserverService, ContentService, LocalStorageService,ApiService } from "@DavisDigital/davisdigitalfrontend.module";
import { FolderTypes, Lesson } from "@DavisDigital/interfaces";
import { returnFocus } from "../services/modal-focus-return";

import * as Shepherd from '../../../../../org/Hibachi/client/lib/shepherd.js/dist/js/shepherd.min.js';

export enum LessonListStorageKeys {
	LastTab = 'lastTab',
	LastSelectedFolder = 'lastSelectedFolder'
}

class LessonListingController {
	
	public currentPage = 1;
	public folderCurrentPage = 1;
	public lessonRecordsPerPage = 8;
	public folderRecordsPerPage = 4;
	public keywords:string = "";
	public sortOrder = '1';
	public sortingOptions: any = [{order : "3", text : "Title A-Z"},
			  {order : "4", text : "Title Z-A"}];
	public selectedFolder: any = {};
	
	public activeLessons: any;
	public activeLessonFolders: any;
	
	// Current listing page. Listing pages include my, shared, sample.
	public lessonType: string;
	public lessonTypeName: string = 'My Lessons';
	
	//permissions
	public permissions;
	
	//Create new Lesson
	public createLesson: boolean = false;
	public hideFolders:boolean = false;
	
	public isLoading: boolean = false;
	public slatwall:any;
	
	public accountSharerList = [];
	public selectedFolderID: string;
	public sharedByAccount: string = "";
		//for sample lession to show to user on welcome
	public featureDate = new Date();
	public davisAccountType:string;
	public displayFirstTimeLanding:boolean;
	public currentFolderTitle: string;
	public currentFolderType_systemCode: FolderTypes;
	public currentFolderArchiveFlag: boolean;
	public currentFolderArchiveFolder_folderID: string;
	
	private readonly lastTabKey: string = LessonListStorageKeys.LastTab;
	private readonly lastSelectedFolderKey: string = LessonListStorageKeys.LastSelectedFolder;
	private readonly lastFolderNameKey: string = "lastFolderName";
	private readonly lastFolderType_systemCodeKey: string = "lastFolderType_systemCode";
	private readonly lastFolderArchiveFlagKey: string = "lastFolderArchiveFlag";
	private readonly lastFolderArchiveFolder_folderIDKey: string = "lastFolderArchiveFolder_folderID";

	// @ngInject
	constructor(
		private $timeout			: ng.ITimeoutService,
		private $location           : ng.IRootElementService,
		public  $rootScope          : ng.IRootScopeService,
		private lessonService       : LessonService,
		private apiService			: ApiService,
	    private listingModalService : ListingModalService,
	    private observerService		: ObserverService,
	    private contentService		: ContentService,
	    private localStorageService : LocalStorageService,
	) {}
	
	
	public $onInit = () => {
		
	}
	
	/**
	 * Called in the view inside ng-init!
	 * 
	 * Separate method to load correct lesson view based on account type
	 * */
	public initializeLesson = (accountType) => {
		this.observerService.attach(this.setPermissions, 'permissions')
		
		var lessonID = this.$location.search().lessonID;
		if(lessonID?.length === 32){
			this.createLesson = true;
		}

		var folderID = this.$location.search().folderID;
		if(folderID?.length === 32){
			this.selectedFolderID = folderID;
		}
		
		if (!folderID || folderID === this.localStorageService.getItem(this.lastSelectedFolderKey)) {
			this.selectedFolderID = this.localStorageService.getItem(this.lastSelectedFolderKey);
			this.currentFolderTitle = this.localStorageService.getItem(this.lastFolderNameKey);
			this.currentFolderType_systemCode = this.localStorageService.getItem(this.lastFolderType_systemCodeKey) as FolderTypes;
			this.currentFolderArchiveFlag = this.localStorageService.getItem(this.lastFolderArchiveFlagKey) === 'true';
			this.currentFolderArchiveFolder_folderID = this.localStorageService.getItem(this.lastFolderArchiveFolder_folderIDKey);
		}
		
		this.lessonType = this.$location.search().lessonType;
		
		this.davisAccountType = accountType;
		
		if( this.davisAccountType=="Student" ) {
			
			this.sortOrder = '2';
			this.sortingOptions.push({order: "2", text: "Recently Created"});
			this.hideFolders = true;
			
		} else {
			
			this.sortingOptions.push({order: "1", text: "Recently Edited"});
		
		}
		
		
		if( !this.displayFirstTimeLanding ) {
			if(this.lessonType == null){
				this.lessonType = this.localStorageService.getItem(this.lastTabKey) || 'my';
			}
			
			this.setLessonType(this.lessonType, this.selectedFolderID == null);

		}
	}
	
	public setPermissions = (permissions) =>{
		this.permissions = permissions;
	}
	
	private initShepherd = () => {
	    
	let continueTour = this.setStorageKey("lessonListing");
	if(!continueTour){
		return;
	}
		
		// Creating Tour
		const tour = new Shepherd.Tour({
            defaultStepOptions: {
                keyboardNavigation: true,
                exitOnEsc: true,
            cancelIcon: {
                enabled: true
            },
            classes: 'custom-davis-tour custom-davis-tour-lesson-listing',
                scrollTo: { behavior: 'smooth', block: 'center' }
            },
            useModalOverlay: true
		});
		
		const addStep = (step: { id: string, title: string, text: string, attachTo: {element: string, on: string }, timeout ?: number  }) => {
    	
    		tour.addStep({
                id: step.id,
                title: step.title,
                text: step.text,
                attachTo: step.attachTo,
    		  
                buttons: [
                    {
                        action: tour.cancel,
                        classes: 'shepherd-button-stop-helper-temporarily',
                        text: 'Stop helper'
                    },
                    {
                        action: tour.complete,
                        classes: 'shepherd-button-stop-helper-forever',
                        text: 'Stop helper and don\'t show again'
                    },
                    {
                        action: tour.next,
                        classes: 'shepherd-button-next',
                        text: 'Next'
                    }
                ],
                beforeShowPromise: function() {
                    return new Promise(function(resolve) {
                    	setTimeout(function(){
                    		resolve();	
                    	}, step.timeout || 0);
                    });
                }
    		});
		};
		
		
		 this.apiService.getTypesByParent('helperTextLessonsListing'). 
			then( data => {
		 	var elements = ['.lesson-tab-my','.lesson-tab-shared','.lesson-tab-sample','.folder:nth-child(1)',
		 	'.create-folder','.create-lesson'];
			for( let index = 0; index < data.length; index++){
			 var positioin='right';
			 if(index==3){
			 	positioin='top';
			 }if(index==4 || index==5){
			 positioin='left';
			 }
			
			 addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/0"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: positioin
							},
						  timeout: 600,
						});
				}
		 tour.start();
		 }); 
	
	}
	
	//param: if tour is for a "new" item tour or "edit" item tour, will show helper so many times, returns false to exit helper
	private setStorageKey = (action : string ) => {
		
	//	let localStorageKey = action == "new" ? 'lesson_editor_new_tour_completed' : "lesson_editor_tour_completed";
	
		let localStorageKey = action;
		
		Shepherd.on('cancel', () => {
			if(!this.localStorageService.getItem(localStorageKey)){
				this.localStorageService.setItem(localStorageKey, '1');
			} else if (this.localStorageService.getItem(localStorageKey) == '1') {
				this.localStorageService.setItem(localStorageKey, '2')
			} else if (this.localStorageService.getItem(localStorageKey) == '2'){
				this.localStorageService.setItem(localStorageKey, '3')
			} else if (this.localStorageService.getItem(localStorageKey) == '3'){
				return false;
			}
		});
	    
	    if(this.localStorageService.getItem(localStorageKey)){
			let storageKey = this.localStorageService.getItem(localStorageKey);
			if( storageKey != '1' && storageKey != '2')
	        return false;
	    }
	    
	    Shepherd.on('complete', (context, args) => {
	    	//ignore complete action if done from last step, so user can see it again on reload
	    		this.localStorageService.setItem(localStorageKey, Date.now());
	    });
	
		//return true to continue shepherd init
		return true;
	}
	    
    public onCreateFolder() {
    	//set my lessons folder type
    	let folderType = FolderTypes.Lesson;
    	//set folder type for shared lessons
    	if ( 'shared' === this.lessonType ) {
    		folderType = FolderTypes.SharedLesson;
    	}
    	
		this.listingModalService.launchAddEditFolderModal( 
		   folderType, 
		   undefined, 
		   undefined, 
		   (success) => {
		       if(success) this.getFolders(false, true);
		   });
    }
	
	public createLessonToggle(type?) {
		this.createLesson = !this.createLesson;
		
		if(type != null){
			this.$location.search( 'lessonType', type );
		}
	}
	
	public applySort() {
		this.refreshLessonsAndFolders(true, true);
	}
	
	private getLessons = ( resetCurrentPage = true, bustCache = true): any => {
		this.isLoading = true;
		
		if ( resetCurrentPage ) {
			this.currentPage = 1;
		}
		
		//initialize active lesson to blank array - to avoid any race condition
		this.activeLessons = [];
		
		let	data = { 
			currentPage: this.currentPage, 
			recordsPerPage: this.lessonRecordsPerPage,
			keywords: this.keywords,
			folderID: this.selectedFolderID,
			folder: this.selectedFolder,
			sortOrder: this.sortOrder,
			bustCache: bustCache,
			sharedByAccount: this.sharedByAccount,
		};
		
		// My lessons.
		if ( 'my' === this.lessonType ) {
			this.lessonService.getMyLessons( data ).then( result => {
				this.isLoading = false;
				this.activeLessons = result;
			});
		} 
		
		// Shared lessons.
		if ( 'shared' === this.lessonType ) {
			this.lessonService.getSharedLessons( data ).then( result => {
				this.isLoading = false;
				this.activeLessons = result;
			});
		} 
		
		// Sample lessons.
		if ( 'sample' === this.lessonType ) {
			this.lessonService.getSampleLessons( data ).then( result => {
				this.isLoading = false;
				this.activeLessons = result;
			});
		}
	}
	
	private getFolders = ( resetCurrentPage = true, bustCache = false): any => {
		
		//Hide Folders
		if( this.hideFolders ) {
			this.activeLessonFolders = [];
			return;
		}
		
		this.isLoading = true;
		
		if ( resetCurrentPage ) {
			this.folderCurrentPage = 1;
			//reset folders array if we're resetting pagination
			this.activeLessonFolders = [];
		}
		
		let data = {
			currentPage: this.folderCurrentPage, 
			recordsPerPage: this.folderRecordsPerPage,
			keywords: this.keywords,
			sortOrder: this.sortOrder,
			folderID: this.selectedFolderID,
			folder: this.selectedFolder,
			bustCache:bustCache,
			folderType: FolderTypes.Lesson,
			sharedByAccount: this.sharedByAccount
		};
		
		// My lesson folders.
		if ( 'my' === this.lessonType ) {
			this.lessonService.getMyLessonFolders( data ).then( result => {
				this.isLoading = false;
				this.activeLessonFolders = result.data;
				
			}).finally(() => 				
				this.$timeout(()=>{	
					if(!this.createLesson && !this.displayFirstTimeLanding){
						this.initShepherd();
					}
				})
			);
		}
		
		// Shurred lesson folders.
		if ( 'shared' === this.lessonType ) {
			
			data['folderType'] = FolderTypes.SharedLesson;
			
			this.lessonService.getSharedLessonFolders( data ).then( result => {
				this.isLoading = false;
				this.activeLessonFolders = result;
			});
		} 
		
		// For sample, we want to remove folders from displaying.
		if ( 'sample' === this.lessonType ) {
			this.activeLessonFolders = [];
		}
	}
	
	public getSharerAccountList = () => {
		if(this.lessonType == "shared"){
			this.contentService.getSharerAccountList('lesson').then((response) => {
				this.accountSharerList = response.data;
			});
		} else {
			this.accountSharerList = [];
		}
	}
	
	public setLessonType = ( lessonType: string, removeSelectedFolder = true ): void => {
		this.lessonType = lessonType;
		
		if( this.davisAccountType=="Student" ) {
			this.lessonType = "shared";
		}
		
		switch ( this.lessonType ) {
			case 'my':
				this.lessonTypeName = 'My Lessons';
				break;
			case 'shared':
				this.lessonTypeName = 'Shared Lessons';
				break;
			case 'sample':
				this.lessonTypeName = 'Sample Lessons';
				break;
		}
		
		this.getSharerAccountList();
		this.$location.search('lessonType', this.lessonType);
		this.localStorageService.setItem(this.lastTabKey, this.lessonType);
		
		if(removeSelectedFolder){
			this.removeSelectedFolder();// this will refreshLessonsAndFolders
		} else {
			this.refreshLessonsAndFolders();
		}
	}
	
	public onSearchSharedByAccount() {
		this.refreshLessonsAndFolders(true, true);
	}
	
	public refreshLessonsAndFolders = ( resetCurrentPage = true, bustCache = true ) =>{
		this.getLessons(resetCurrentPage, bustCache);
		this.getFolders(resetCurrentPage, bustCache);
	}
	
	public handleLessonPageChange = ( pageNumber: number ) => {
		this.currentPage = pageNumber;
		this.getLessons( false );
	}
	
	public handleFolderPageChange = ( pageNumber: number ) => {
		this.folderCurrentPage = pageNumber;
		this.getFolders( false );
	}
	
	/**
	 * Funtion to rename folder form folder view page
	 * 
	 * //Callback function expects 
	 * */
	public renameFolder = ( ) => {
		this.listingModalService.launchAddEditFolderModal(
	        this.currentFolderType_systemCode, 
	        this.selectedFolderID,
	        this.currentFolderTitle,
	        (result) => {
	            if(result.status == true){
			        this.selectedFolder.title = result.folderName;
			        this.currentFolderTitle = result.folderName;
			        this.localStorageService.setItem(this.lastFolderNameKey, result.folderName);
	            }
	        },
	        'listing'
	   );
	}
	
	public setSelectedFolder = ( folder ) => {
		
		folder.archiveFlag = folder.archiveFlag != " " ? folder.archiveFlag:false;
		
		this.hideFolders = !folder.archiveFlag;
		this.selectedFolderID = folder.folderID;
		this.selectedFolder = folder;
		this.localStorageService.setItem(this.lastFolderNameKey, folder.title);
		this.localStorageService.setItem(this.lastFolderType_systemCodeKey, folder.folderType_systemCode);
		this.localStorageService.setItem(this.lastFolderArchiveFlagKey, folder.archiveFlag);
		this.localStorageService.setItem(this.lastFolderArchiveFolder_folderIDKey, folder.archiveFolder_folderID);
		this.localStorageService.setItem(this.lastSelectedFolderKey, folder.folderID);
		
		this.currentFolderTitle = folder.title;
		this.currentFolderType_systemCode = folder.folderType_systemCode;
		this.currentFolderArchiveFlag = folder.archiveFlag;
		this.currentFolderArchiveFolder_folderID = folder.archiveFolder_folderID;
		
		this.$location.search( 'folderID', folder.folderID );
		this.refreshLessonsAndFolders( true, true );
	}
	
	public removeSelectedFolder = () => {
		this.hideFolders = false;
		this.selectedFolderID = null;
		this.selectedFolder = {};
		this.currentFolderTitle = null;
		this.currentFolderType_systemCode = null;
		this.currentFolderArchiveFlag = false;
		this.currentFolderArchiveFolder_folderID = null;
		this.$location.search('folderID', null);
		this.localStorageService.removeItem(this.lastSelectedFolderKey);
		this.localStorageService.removeItem(this.lastFolderType_systemCodeKey);
		this.localStorageService.removeItem(this.lastFolderArchiveFlagKey);
		this.localStorageService.removeItem(this.lastFolderArchiveFolder_folderIDKey);
		this.refreshLessonsAndFolders( true, true );
	}
	
	public getFeaturedLessons = ( resetCurrentPage = true, bustCache = false): any => {
		 
		this.isLoading = true;
		
		if ( resetCurrentPage ) {
			this.currentPage = 1;
		}
		
		let data = { 
			currentPage: this.currentPage, 
			recordsPerPage: this.lessonRecordsPerPage,
			keywords: this.keywords,
			folder: this.selectedFolder,
			sortOrder: this.sortOrder,
			bustCache: bustCache
		}
		
		// Sample lessons.
		this.lessonService.getSampleLessons( data ).then( result => {
			this.isLoading = false;
			this.activeLessons = result;
			this.featureDate = new Date();
		}).finally(()=>{this.$timeout(()=>{this.initFeaturedSlider(); this.setSlickSliderHeight('.slick-slide'); this.setSlickSliderHeight('.card__tile__copy')}, 500)});
		
	  }
	  
	  public initFeaturedSlider = () => {
	  		$('.featured-slider').slick({
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 4,
		prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="fas fa-chevron-left"></i></button>',
		nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="fas fa-chevron-right"></i></button>',
		responsive: [
		{
		  breakpoint: 1199,
		  settings: {
			slidesToShow: 3,
			slidesToScroll: 3,
		  }
		},
		{
		  breakpoint: 991,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2
		  }
		},
		{
		  breakpoint: 767,
		  settings: "unslick"
		}
	  ]
	});

	  }
	  
	public setSlickSliderHeight = (classElement) => {
		let slickSliderHeight = 0;
		let slickSliderMaxHeight = 0;
		$(classElement).each(function(){
			slickSliderHeight = $(this).outerHeight();
			if(slickSliderHeight >= slickSliderMaxHeight){
				slickSliderMaxHeight = slickSliderHeight;  
			}
		});
			$(classElement).innerHeight(slickSliderMaxHeight);
	}   
	
	/** Function to handle view all sample lessons click on new user landing page 
	* @param - action, it will be tab type name
	**/
	public handleUserLandingSampleViewAll = (action:string = "sample") => {
		this.displayFirstTimeLanding = false;
		this.setLessonType(action);
	}
	
	/** Method to handle duplicate action for sample lessons on new user landing page **/
	public sampleDuplicate = (lesson: Lesson) => {
		
		//Action type added to differentiate duplicate and save to my lesson action
		let actionType = "duplicate";
		
		// WCAG 2.4.3 / 2.1.2 focus management for the sample-lessons Duplicate dialog only.
		// angular-modal-service blurs the trigger on open and never traps/restores focus,
		// so (a) keyboard users tab through the page behind the dialog before reaching it
		// and (b) focus is lost to <body> on close. This is scoped to this call site so no
		// other Duplicate modal caller (lesson-card, portfolio-card, lesson-editor) changes.
		const trigger = document.activeElement as HTMLElement;
		this.enableSampleDuplicateFocusManagement(trigger);
		
	    this.listingModalService.launchDuplicateModal(lesson, null, (success) => {
	        if( success ){ this.handleUserLandingSampleViewAll("my") }
	    }, actionType);
	}
	
	/** focusin capture listener for the sample-duplicate focus trap; kept so it can be removed. */
	private sampleDuplicateFocusinListener: ((e: FocusEvent) => void) | null = null;
	
	/** Returns focusable controls currently reachable inside the duplicate dialog. */
	private getSampleDuplicateFocusables = (dialog: HTMLElement): HTMLElement[] => {
		const selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
		const nodes = dialog.querySelectorAll(selector);
		return Array.prototype.filter.call(nodes, (el: HTMLElement) =>
			!(el as HTMLButtonElement).disabled &&
			el.getAttribute('aria-hidden') !== 'true' &&
			el.getClientRects().length > 0
		);
	}
	
	/**
	 * Trap keyboard focus inside the sample-lessons Duplicate dialog while it is open and
	 * return focus to the triggering ... control when it closes. Self-contained: it waits
	 * for the shared modal markup (#lessonDuplicateModal) to appear and to be removed, so
	 * the shared ModalService / duplicate-modal component are left untouched.
	 */
	private enableSampleDuplicateFocusManagement = (trigger: HTMLElement) => {
		const getDialog = (): HTMLElement | null =>
			document.getElementById('lessonDuplicateModal');
		
		const teardown = () => {
			if (this.sampleDuplicateFocusinListener) {
				document.removeEventListener('focusin', this.sampleDuplicateFocusinListener, true);
				this.sampleDuplicateFocusinListener = null;
			}
		};
		
		// Never leave a document-level listener behind if the view is destroyed while open.
		this.$rootScope.$on('$destroy', teardown);
		
		// Poll briefly for the dialog to be inserted (angular-modal-service appends async).
		let attempts = 0;
		const waitForOpen = () => {
			const dialog = getDialog();
			if (dialog && this.getSampleDuplicateFocusables(dialog).length) {
				// Move focus into the dialog (prefer the Close button, else first focusable).
				const focusables = this.getSampleDuplicateFocusables(dialog);
				const closeBtn = dialog.querySelector('.close') as HTMLElement;
				(closeBtn && focusables.indexOf(closeBtn) !== -1 ? closeBtn : focusables[0]).focus();
				
				// Trap: if focus escapes the dialog by any route, pull it back inside.
				this.sampleDuplicateFocusinListener = (e: FocusEvent) => {
					const d = getDialog();
					if (!d) return;
					const target = e.target as HTMLElement;
					if (d.contains(target)) return;
					const f = this.getSampleDuplicateFocusables(d);
					if (f.length) f[0].focus();
				};
				document.addEventListener('focusin', this.sampleDuplicateFocusinListener, true);
				
				waitForClose();
				return;
			}
			if (attempts++ < 40) { this.$timeout(waitForOpen, 50, false); }
		};
		
		// Once open, poll for the dialog's removal, then release the trap and restore focus.
		const waitForClose = () => {
			if (getDialog()) { this.$timeout(waitForClose, 100, false); return; }
			teardown();
			// returnFocus falls back to the ellipsis toggle if the menu item is now hidden.
			this.$timeout(() => returnFocus(trigger), 0, false);
		};
		
		this.$timeout(waitForOpen, 50, false);
	}
}

export { LessonListingController };